import { render, staticRenderFns } from "./ExplanatoryNoteTabs.vue?vue&type=template&id=271e3a14&"
import script from "./ExplanatoryNoteTabs.vue?vue&type=script&lang=js&"
export * from "./ExplanatoryNoteTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports